/* ==============================================================================================
 * FADE SCROLLABLE
 * ============================================================================================== */

var Sushi, $ = window.jQuery;

(function (Sushi) {
	"use strict";

	var FadeScrollable;

	FadeScrollable = function (triggerElement, options) {
		Sushi.Plugins.BasePlugin.call(this, triggerElement, options);

		this.init();
	};

	FadeScrollable.displayName = "FadeScrollable";

	FadeScrollable.DEFAULTS = {
		mode: "horizontal",
		scrollThreshold: 25,
		throttleTimeout: 100,
		trackQuery: null,
		bare: false, // Add a "bare" class, to prevent default styling
	};

	FadeScrollable.prototype = Object.create(Sushi.Plugins.BasePlugin.prototype);
	FadeScrollable.state = Object.create({
		maxScrollAmount: 0,
		scrollAmount: 0,
	});

	var proto = FadeScrollable.prototype;
	var state = FadeScrollable.state;

	proto.constructor = FadeScrollable;

	proto.init = function () {
		setTimeout(function () {
			try {
				this.update();
				this.addEventListeners();
			}
			catch (err) {
				// eslint-disable-next-line no-console
				console.warn(
					"Could initialize FadeScrollable: " + err.message,
					this.triggerElement
				);

				return;
			}

			this.setupTriggerClasses();
		}.bind(this));
	};

	proto.update = function () {
		this.track = this.getTrack() || null;
		this.content = this.getContent() || null;

		this.updateMaxScrollAmount();
		this.updateFadeClasses();
	};

	proto.addEventListeners = function () {
		this.track.addEventListener("scroll", Sushi.Util.throttle(function () {
			this.updateMaxScrollAmount();
			this.updateScrollAmount();
			this.updateFadeClasses();
		}.bind(this), this.options.throttleTimeout));

		window.addEventListener("resize", this.update.bind(this));
	};

	proto.getTrack = function () {
		if (this.options.trackQuery) {
			return $(this.triggerElement).find(this.options.trackQuery)[0];
		}

		return this.triggerElement.querySelector("[data-fade-scrollable-track]")
			|| this.triggerElement;
	};

	proto.getContent = function () {
		return this.triggerElement.querySelector("[data-fade-scrollable-content]");
	};

	proto.updateScrollAmount = function () {
		if (this.options.mode === "horizontal") {
			state.scrollAmount = this.track.scrollLeft;
		}

		if (this.options.mode === "vertical") {
			state.scrollAmount = this.track.scrollTop;
		}
	};

	proto.updateMaxScrollAmount = function () {
		if (this.options.mode === "horizontal") {
			state.maxScrollAmount = this.content.clientWidth - this.track.clientWidth;
		}

		if (this.options.mode === "vertical") {
			state.maxScrollAmount = this.content.clientHeight - this.track.clientHeight;
		}
	};

	proto.updateFadeClasses = function () {
		var fadeStart = state.scrollAmount > this.options.scrollThreshold;
		var fadeEnd = (state.maxScrollAmount - state.scrollAmount)
			> this.options.scrollThreshold;

		this.triggerElement.classList[fadeStart ? "add" : "remove"]("c-fadeScrollable--fadeStart");
		this.triggerElement.classList[fadeEnd ? "add" : "remove"]("c-fadeScrollable--fadeEnd");
	};

	proto.setupTriggerClasses = function () {
		this.triggerElement.classList.add("c-fadeScrollable");
		this.track.classList.add("c-fadeScrollable__track");
		this.content.classList.add("c-fadeScrollable__content");

		if (this.options.mode === "horizontal") {
			this.triggerElement.classList.add("c-fadeScrollable--horizontal");
		}

		if (this.options.mode === "vertical") {
			this.triggerElement.classList.add("c-fadeScrollable--vertical");
		}

		if (this.options.bare) {
			this.triggerElement.classList.add("c-fadeScrollable--bare");
		}
	};

	Sushi.Plugins.FadeScrollable = FadeScrollable;

})(Sushi || (Sushi = {}));
